import type { GetContractsResponse } from '@vy/api-definition';
import { GetContractsResponseSchema } from '@vy/api-definition';
import { isEmptyString, vySerialize, withNewOptionalValue } from '@vy/utils';
import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';

import { useContractsFilters } from '../../../pages/plans/PlansPage/plans-page-hooks/use-contracts-filters';
import { useContractStatusesParam } from '../../../pages/plans/PlansPage/plans-page-components/hooks/use-contract-statuses-param';
import { useAdditionalFiltersParam } from '../../../pages/plans/PlansPage/plans-page-components/hooks/use-additional-filters-param';
import { useTableSorting } from '../../use-table-sorting';
import { getPrivateApi } from '../../../services/api';
import { queryKeys } from '../../../services/query-key/query-keys';

const PAGE = 0;
const PAGE_SIZE = 1000;

export function useNonPagedContractsFromParams(options?: UseMutationOptions<GetContractsResponse, unknown>) {
  const { query, filters } = useContractsFilters();
  const { currentSortModel } = useTableSorting();
  const [contractStatuses] = useContractStatusesParam();
  const [additionalFilters] = useAdditionalFiltersParam();

  const payload = {
    search: isEmptyString(query) ? undefined : query,
    contractFilters: filters?.length ? vySerialize(filters) : undefined,
    page: PAGE,
    pageSize: PAGE_SIZE,
    sort: withNewOptionalValue(currentSortModel, vySerialize),
    contractStatuses: contractStatuses?.length ? vySerialize(contractStatuses) : undefined,
    additionalFilters: additionalFilters?.length ? vySerialize(additionalFilters) : undefined,
  };

  return useMutation({
    mutationKey: queryKeys.contracts(...Object.values(payload)),
    mutationFn: async () => {
      const api = getPrivateApi();
      const getContractsResponse = await api.getContracts(payload);

      return GetContractsResponseSchema.parse(getContractsResponse);
    },
    ...options,
  });
}
